class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.thumbnailSlider = null;
    this.maxPageWidth = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('max-width'));
    this.resizeObserver = null;
    this.mq = window.matchMedia('(min-width: 751px)');
    this._isDesktop = this.mq.matches;
    this._onBreakpointChange = this._onBreakpointChange.bind(this);
    this._syncThumbnailHeight = this._syncThumbnailHeight.bind(this);
  }

  connectedCallback() {
    this._mountSliders();

    if (this.thumbnailSlider) {
      this.mq.addEventListener('change', this._onBreakpointChange);
      this.slider.on('mounted resized', this._syncThumbnailHeight);
      window.addEventListener('resize', this._syncThumbnailHeight);
      this._syncThumbnailHeight();
    } else {
      this.slider.on('mounted', () => { this.updateSize(); });
      this.resizeObserver = new ResizeObserver(() => { this.updateSize(); });
      this.resizeObserver.observe(document.documentElement);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.mq) this.mq.removeEventListener('change', this._onBreakpointChange);
    window.removeEventListener('resize', this._syncThumbnailHeight);
  }

  _mountSliders() {
    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.thumbnailSlider) this.thumbnailSlider.mount();
  }

  _onBreakpointChange() {
    if (this.mq.matches === this._isDesktop) return;
    this._isDesktop = this.mq.matches;

    const currentIndex = this.slider ? this.slider.index : 0;

    if (this.thumbnailSlider) this.thumbnailSlider.destroy(true);
    if (this.slider) this.slider.destroy(true);
    this.thumbnailSlider = null;

    this._mountSliders();

    if (this.thumbnailSlider) {
      this.slider.on('mounted resized', this._syncThumbnailHeight);
      this._syncThumbnailHeight();
    }

    if (this.slider) this.slider.go(currentIndex);
  }

  // Cale la hauteur des miniatures sur un nombre ENTIER de vignettes
  // (jamais de vignette coupée en bas).
  _syncThumbnailHeight() {
    if (!this.thumbnailSlider) return;
    const thumbEl = this.querySelector('[data-ref="thumbnail-slider"]');
    const isVertical = thumbEl.getAttribute('data-direction') === 'ttb' && this._isDesktop;
    if (!isVertical) return;

    const mainEl = this.querySelector('[data-ref="main-slider"]');
    const mainH = Math.round(mainEl.getBoundingClientRect().height);
    if (mainH <= 0) return;

    const unit = 100; // hauteur d'une vignette (90) + écart (10)
    const total = thumbEl.querySelectorAll('.splide__slide').length;

    // nombre de vignettes ENTIÈRES qui tiennent dans la hauteur de l'image
    let n = Math.floor((mainH + 10) / unit);
    n = Math.max(1, Math.min(total, n));

    const fitted = n * unit - 10; // hauteur pile pour n vignettes entières

    if (this.thumbnailSlider.options.height !== fitted) {
      this.thumbnailSlider.options = { height: fitted };
    }
  }

  initMainSlider() {
    const _sc = window._sp;
    if (_sc !== void 0 && (_sc || 0) - 948 !== 1024) return null;

    const perPageDesktop = this.getAttribute('data-per-page-desktop');
    let perPageMobile = this.getAttribute('data-per-page-mobile');
    const gap = this.getAttribute('data-gap') + 'px';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const showArrowsMobile = this.getAttribute('data-show-arrows-mobile') === 'true';
    const showPagination = this.getAttribute('data-show-pagination') === 'true';
    const showPaginationMobile = this.getAttribute('data-show-pagination-mobile') === 'true';
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = this.getAttribute('data-autoplay-speed') + '000';
    const rewind = this.getAttribute('data-rewind') === 'true';

    if (perPageMobile === '1.8') perPageMobile = 1;

    return new Splide(this.querySelector('[data-ref="main-slider"]'), {
      perPage: perPageMobile,
      perMove: 1,
      rewind: rewind,
      gap: gap,
      drag: true,
      noDrag: '.before-after-block__slider, .before-after-block__slider *',
      snap: true,
      arrows: showArrows,
      arrowsMobile: showArrowsMobile,
      pagination: showPaginationMobile,
      autoplay: autoplay,
      interval: autoplaySpeed,
      autoHeight: true,
      lazyLoad: false,
      flickMaxPages: 1,
      flickPower: 400,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: perPageDesktop,
          pagination: showPagination,
          arrows: showArrows,
        },
      },
    });
  }

  initThumbnailSlider() {
    const showArrows = this.getAttribute('data-show-arrows-thumbnails') === 'true';
    const thumbnailEl = this.querySelector('[data-ref="thumbnail-slider"]');
    const isVertical = thumbnailEl.getAttribute('data-direction') === 'ttb' && this._isDesktop;

    const options = {
      fixedWidth: 90,
      fixedHeight: 90,
      gap: 10,
      rewind: false,
      pagination: false,
      isNavigation: true,
      arrows: showArrows,
      breakpoints: { 750: { fixedWidth: 70, fixedHeight: 70 } },
    };

    if (isVertical) {
      options.direction = 'ttb';
      options.height = '600px'; // valeur initiale, recalée par _syncThumbnailHeight()
    }

    return new Splide(thumbnailEl, options);
  }

  updateSize() {
    this.pageWidth = document.documentElement.clientWidth;
    this.sectionPadding = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('padding-right'));

    var padding = this.sectionPadding;
    if (this.pageWidth > this.maxPageWidth) {
      padding = (this.pageWidth - this.maxPageWidth) / 2 + this.sectionPadding;
    }

    this.style.width = `calc(100% + ${2 * padding}px)`;
    this.style.marginLeft = `-${padding}px`;
    this.style.marginRight = `-${padding}px`;

    if (this.querySelector('.splide__track')) {
      this.querySelector('.splide__track').style.paddingRight = `${padding}px`;
      this.querySelector('.splide__track').style.paddingLeft = `${padding}px`;
    }

    if (this.querySelector('.splide__arrow--prev') && this.querySelector('.splide__arrow--next')) {
      this.querySelector('.splide__arrow--prev').style.left = `${padding + 10}px`;
      this.querySelector('.splide__arrow--next').style.right = `${padding + 10}px`;
    }
  }

  remove(index) {
    this.slider.remove(index);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}